import React, { useCallback, useContext } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH, MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { useHistoryWithState } from 'shared/hooks/useHistoryWithState'
import { BonusPromotionStatus } from 'shared/models/Promotion'
import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { selectLocaleDict } from 'features/locale/selectors'
import { setIsActivatedFreeSpin } from 'features/slots/actions'

import { ModalContext } from 'components/HOC/withModalQuery/ModalContext'

import Button from 'components/UIKit/Button/Button'

import './FreeSpinModal.scss'

interface IFreeSpinModalProps {
  path?: string
}

const b = block('free-spin-modal')

const FreeSpinModal: React.FC<IFreeSpinModalProps> = ({ path = '' }) => {
  const historyWithState = useHistoryWithState()
  const { closeModal } = useContext(ModalContext)
  const dispatch = useDispatch()
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const params = getRouteParamsByStrings<IFreeSpinModalProps>(MODAL_ROUTE_PATH.FREE_SPIN_MODAL, path)

  const handleClickButton = useCallback(() => {
    if (params?.path === 'start') {
      dispatch(setIsActivatedFreeSpin(true))
    } else {
      dispatch(setIsActivatedFreeSpin(false))
    }
    const prevPath = historyWithState.location.state?.prevPath ?? '/'
    history.replaceState(path, '', prevPath)
    closeModal(MODAL_ROUTE_URLS.FREE_SPIN_MODAL(params?.path || 'start'))()
    if (params?.path === 'end') {
      historyWithState.push(`${ROUTE_URLS.PROFILE_PROMOTIONS()}?status=${BonusPromotionStatus.active}`)
    }
  }, [closeModal, historyWithState, params?.path, path, dispatch])

  return (
    <div className={b()}>
      <div className={b('header')}>{params?.path === 'end' ? locale.spinsAreOver : locale.freeSpinStartHeader}</div>
      <div className={b('content')}>{params?.path === 'end' ? locale.freeSpinsAreOver : locale.freeSpinStart}</div>
      <div className={b('button-wrapper')}>
        <div className={b('button')}>
          <Button text={params?.path === 'end' ? locale.promotions : locale.continue} callback={handleClickButton} />
        </div>
      </div>
    </div>
  )
}

export default FreeSpinModal
